import { render, staticRenderFns } from "./InscripcionesProductividadLayout.vue?vue&type=template&id=35a0d064&scoped=true"
import script from "./InscripcionesProductividadLayout.vue?vue&type=script&lang=js"
export * from "./InscripcionesProductividadLayout.vue?vue&type=script&lang=js"
import style0 from "./InscripcionesProductividadLayout.vue?vue&type=style&index=0&id=35a0d064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a0d064",
  null
  
)

export default component.exports